module.exports = __webpack_public_path__ + "assets/img/activityImg4-33d64898.png";